"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URI = 'composition/v1/googledrive';

var getDocImportURI = function getDocImportURI(fileId, compositionId) {
  return BASE_URI + "/" + fileId + "/to-composition/" + compositionId;
};

var GoogleDocManager = /*#__PURE__*/function () {
  function GoogleDocManager() {
    (0, _classCallCheck2.default)(this, GoogleDocManager);
  }

  (0, _createClass2.default)(GoogleDocManager, [{
    key: "getAllAccounts",
    value: function getAllAccounts() {
      return _apiClient.default.get(BASE_URI + "/auth-info");
    }
  }, {
    key: "getDefaultAuthInfo",
    value: function getDefaultAuthInfo(email) {
      return _apiClient.default.get(BASE_URI + "/default-auth-info", {
        query: {
          email: email
        }
      });
    }
  }, {
    key: "getValidAuthInfo",
    value: function getValidAuthInfo(email) {
      return _apiClient.default.get(BASE_URI + "/validate-auth-info", {
        query: {
          email: email
        }
      });
    }
  }, {
    key: "importGoogleDocToComposition",
    value: function importGoogleDocToComposition(fileId, compositionId, email) {
      var builtUri = getDocImportURI(fileId, compositionId);
      return _apiClient.default.put(builtUri, {
        query: {
          email: email
        }
      });
    }
  }]);
  return GoogleDocManager;
}();

exports.default = GoogleDocManager;
module.exports = exports.default;